"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_06bc3313{display:table-row}.resultContent_06bc3313 .resultItem_06bc3313{display:table-cell;vertical-align:bottom}.peoplePickerPersona_06bc3313{width:180px}.peoplePickerPersona_06bc3313 .ms-Persona-details{width:100%}.peoplePicker_06bc3313 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_06bc3313{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n" }]);
exports.resultContent = "resultContent_06bc3313";
exports.resultItem = "resultItem_06bc3313";
exports.peoplePickerPersona = "peoplePickerPersona_06bc3313";
exports.peoplePicker = "peoplePicker_06bc3313";
exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_06bc3313";
//# sourceMappingURL=PeoplePicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/pickers/PeoplePicker/PeoplePicker.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/pickers/PeoplePicker/PeoplePicker.scss.js
// module chunks = 1